// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__UI2HF","clear":"FiltersBlock_clear__9f1mj","filters_close":"FiltersBlock_filters_close__U14Zs"};